import { render, staticRenderFns } from "./TransferNftTable.vue?vue&type=template&id=2c78950f&"
import script from "./TransferNftTable.vue?vue&type=script&lang=js&"
export * from "./TransferNftTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports